export type EnergyExchangeConditionUI = {
	cond_name: string;
	value: number | string;
	exchange_market: string;
	operator: string;
	character: string;
	minutes: number | string;
};

export function is_energy_exchange_ui(obj: any): obj is EnergyExchangeConditionUI {
	return (
		typeof obj === 'object' &&
		typeof obj.cond_name === 'string' &&
		typeof obj.value === 'number' &&
		typeof obj.exchange_market === 'string' &&
		typeof obj.operator === 'string'
	);
}
